import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import DocumentViewer from "../../components/common/DocumentViewer";
import { getDocument, saveDocumentEditor, getDocumentEditor } from "../../api";
import { Loader } from "@progress/kendo-react-indicators";
import { downloadDocument, downloadDocumentAsPDF } from "../../api";
import { toast } from "react-toastify";
import { Dialog } from "@progress/kendo-react-dialogs";
import { BiErrorCircle } from "react-icons/bi";

const DocumentViewerPage = () => {
  const [searchParams] = useSearchParams();
  const [documentData, setDocumentData] = useState(null);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [documentId, setDocumentId] = useState(null);
  const [matterRef, setMatterRef] = useState(null);
  const encodedId = searchParams.get("id");
  const [matterId, setMatterId] = useState(null);
  useEffect(() => {
    if (encodedId) {
      try {
        const decodedString = atob(encodedId);
        const { id, matterRef: decodedMatterRef, matterId } = JSON.parse(decodedString);
        setDocumentId(id);
        setMatterRef(decodedMatterRef);
        setMatterId(matterId);
      } catch (error) {
        console.error("Error decoding ID:", error);
        setErrorMessage("Invalid document link");
        setShowErrorModal(true);
      }
    }
  }, [encodedId]);

  const fetchDocument = async (id) => {
    if (id) {
      try {
        const { data } = await getDocument(id);
        setDocumentData(data.data);
      } catch (error) {
        console.error("Error fetching document:", error);
        setErrorMessage("Document not available or access denied");
        setShowErrorModal(true);
      }
    }
  };

  useEffect(() => {
    fetchDocument(documentId);
  }, [documentId]);

  const handleRefresh = async (id) => {
    await fetchDocument(id);
  };

  const handleDownload = async (documentId, asPDF = false) => {
    try {
      const response = asPDF
        ? await downloadDocumentAsPDF(documentId)
        : await downloadDocument(documentId);

      let fileName;
      const contentDisposition = response.headers["content-disposition"];

      if (response.data?.filename) {
        fileName = response.data.filename;
      } else if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        );
        if (fileNameMatch && fileNameMatch[1]) {
          fileName = fileNameMatch[1].replace(/['"]/g, "");
        }
      }

      if (!fileName) {
        fileName =
          (response.data?.fileID || "downloaded-document") +
          (asPDF ? ".pdf" : "");
      }

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const tempLink = document.createElement("a");
      tempLink.href = url;
      tempLink.setAttribute("download", fileName);
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(url);
    } catch (error) {
    }
  };

  const getDocumentEditorData = async (id, type) => {
    try {
      const { data } = await getDocumentEditor(id, documentId);
      let editUrl = data?.data?.editURL;
      if (type === "Local") {
        let ext = "";
        if (documentData?.documentName) {
          ext = documentData.documentName.split(".").pop().toLowerCase();
        }
        if (["xls", "xlsx"].includes(ext)) {
          editUrl = `ms-excel:ofe|u|${editUrl}`;
        } else {
          editUrl = `ms-word:ofe|u|${editUrl}`;
        }
      }
      window.open(editUrl, "_blank");
    } catch (error) {
      const statusCode = error?.response?.status;
      if (statusCode !== 460) {
      }
    }
  };

  const saveDocuemntEdit = async (id) => {
    try {
      await saveDocumentEditor(id, documentId);
      toast.success("Document Saved");
      handleRefresh(id);
    } catch (error) {
    }
  };

  if (!documentData && !showErrorModal) {
    return (
      <Loader
        themeColor={"warning"}
        size={"large"}
        type={"pulsing"}
        style={{
          position: "absolute",
          top: "45%",
          left: "40%",
          zIndex: 100,
        }}
      />
    );
  }

  if (showErrorModal) {
    return (
      <Dialog width={400} height={230}>
        <div className="d-flex flex-column justify-content-around align-items-center h-100 px-5 text-center">
          <BiErrorCircle color="red" size={"50px"} />
          <p style={{ fontWeight: "500", fontSize: "18px" }}>{errorMessage}</p>
          <button
            className="common-btn border-0"
            onClick={() => window.close()}
          >
            Close
          </button>
        </div>
      </Dialog>
    );
  }

  return (
    <div style={{ height: "100vh", width: "100vw" }}>
      <DocumentViewer
        matterId={matterId}
        onRefresh={handleRefresh}
        data={[documentData]}
        saveDocuemntEdit={saveDocuemntEdit}
        onEditDoc={(e, type) => getDocumentEditorData(e, type)}
        onClose={() => window.close()}
        onDownload={handleDownload}
        component={"CASE-FILES"}
        openedFromPreview={true}
        isStandalone={true}
        matterRef={matterRef}
      />
    </div>
  );
};

export default DocumentViewerPage;
